<ng-container [formGroup]="group">
    <div class="email-select">
        <kendo-multiselect
                [data]="contacts$ | async"
                [textField]="'name'"
                [valueField]="'email'"
                [allowCustom]="true"
                formControlName="address"
                placeholder="Adres e-mail odbiorcy"
                (filterChange)="handleFilterChange($event)"
                [valuePrimitive]="true"
                [valueNormalizer]="valueNormalizer"
        >
        </kendo-multiselect>
    </div>
</ng-container>
